import { render, staticRenderFns } from "./editBak.vue?vue&type=template&id=57a32545&scoped=true&"
import script from "./editBak.vue?vue&type=script&lang=js&"
export * from "./editBak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a32545",
  null
  
)

export default component.exports